import React from 'react'
import _ from 'lodash'
import share from '~/tools/share'

class SharingFooter extends React.PureComponent {
  constructor(props) {
    super(props)

    this.shareTwitter =  this.shareTwitter.bind(this)
    this.shareFacebook =  this.shareFacebook.bind(this)
    this.shareEmail =  this.shareEmail.bind(this)
  }

  shareTwitter() {
    this.share('twitter')
  }

  shareFacebook() {
    this.share('facebook')
  }

  shareEmail() {
    this.share('email')
  }

  share(platform) {
    share[platform](this.props.path, this.props.title)
  }

  render() {
    return (
      <div className="sharing-footer">
        <div className="share-prompt">
          <div className="text">{this.props.type? `SHARE THIS ${this.props.type}` : 'SHARE THIS ARTICLE'}</div>
          <div className="line site-background-color"></div>
        </div>
        <div className="share-btns">
          <div 
            tabIndex="0" 
            onKeyPress={ e => e.key === 'Enter' && this.shareTwitter()} 
            className="share-btn-container"
          >
            <i className="ion-social-twitter" onClick={ this.shareTwitter } />
            <div className="underline site-background-color" />
          </div>
          <div 
            tabIndex="0" 
            onKeyPress={ e => e.key === 'Enter' && this.shareFacebook()} 
            className="share-btn-container"
          >
            <i className="ion-social-facebook" onClick={ this.shareFacebook } />
            <div className="underline site-background-color" />
          </div>
          <div 
            tabIndex="0" 
            onKeyPress={ e => e.key === 'Enter' && this.shareEmail()} 
            className="share-btn-container"
          >
            <i className="ion-ios-email" onClick={ this.shareEmail } />
            <div className="underline site-background-color" />
          </div>
        </div>
      </div>
    )
  }
}

export default SharingFooter;